import { DecimalPipe, NgClass} from '@angular/common';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import { Chip } from 'primeng/chip';
import { DatePicker } from 'primeng/datepicker';
import { InputNumber } from 'primeng/inputnumber';
import { PickList, PickListMoveAllToSourceEvent, PickListMoveAllToTargetEvent, PickListMoveToSourceEvent, PickListMoveToTargetEvent } from 'primeng/picklist';
import { RadioButton } from 'primeng/radiobutton';
import { Select } from 'primeng/select';
import { SelectButton } from 'primeng/selectbutton';
import { Tooltip } from 'primeng/tooltip';
import { SpsCustomIconComponent } from '../../../../custom/components/sps-custom-icon/sps-custom-icon.component';
import { PaymentPageLinkDialog } from '../../../interfaces/payment-page/payment-page-link-dialog';
import { PaymentData } from '../../../interfaces/payment/payment-data';
import { BaseAddPaymentPageLinkComponent } from '../../base/base-add-payment-page-link.component';

@Component({
  selector: 'add-form-payment-page-link-payment',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    NgClass,
    InputNumber,
    Select,
    RadioButton,
    DatePicker,
    PickList,
    SpsCustomIconComponent,
    Tooltip,
    SelectButton,
    Chip,
    DecimalPipe,
    Checkbox
  ],
  templateUrl: './add-form-payment-page-link-payment.component.html'
})
export class AddFormPaymentPageLinkPaymentComponent extends BaseAddPaymentPageLinkComponent implements OnInit, AfterViewInit {

  @Input() addPaymentPageLinkDialog: PaymentPageLinkDialog;
  @Input() paymentMethodsList: PaymentData[];

  protected readonly Date = Date;

  /**
   * payment list parameters
   */
  availablePaymentMethods: PaymentData[];
  selectedPaymentMethods: PaymentData[];

  /**
   * only dates in future
   */
  tomorrow: Date;

  /** Options for amountType */
  amountTypeOptions = [
    {value: 'CUSTOM', label: this.i18n.i18nLng()['CUSTOMAMOUNT']},
    {value: 'FIXED', label: this.i18n.i18nLng()['FIXEDAMOUNT']},
  ];
  newDonationAmount: number = null;

  ngOnInit() {
    // For the PrimeNG datePicker expirationDate has to be in a valid Date format
    if (this.paymentPageLinkData.expirationDate) {
      this.paymentPageLinkData.expirationDate = new Date(this.paymentPageLinkData.expirationDate);
    }
    // Filter Chargeback Cards
    let cleanPaymentMethodsList: PaymentData[] = this.paymentMethodsList;
    cleanPaymentMethodsList = cleanPaymentMethodsList.filter(paymentMethod => !paymentMethod.isChargebackCard)
    this.availablePaymentMethods = cleanPaymentMethodsList.filter(paymentMethod => !this.paymentPageLinkData.paymentTypeIds.includes(paymentMethod.id));
    this.selectedPaymentMethods = cleanPaymentMethodsList.filter(paymentMethod => this.paymentPageLinkData.paymentTypeIds.includes(paymentMethod.id));
    // this.availablePaymentMethods = this.paymentMethodsList.filter(paymentMethod => !this.paymentPageLinkData.paymentTypeIds.includes(paymentMethod.id));
    // this.selectedPaymentMethods = this.paymentMethodsList.filter(paymentMethod => this.paymentPageLinkData.paymentTypeIds.includes(paymentMethod.id));
    this.tomorrow = new Date(this.today);
    this.tomorrow.setDate(this.today.getDate() + 1);
  }

  ngAfterViewInit(): void {
  }


  /**
   * add single payment-method
   * @param event
   */
  addPaymentMethod(event: PickListMoveToSourceEvent) {
    event.items.map(item => {
      this.paymentPageLinkData.paymentTypeIds.push(item.id.toString());
    });
    this.dataChanged.emit();
  }

  /**
   * add all available payment-methods
   * @param event
   */
  addPaymentMethods(event: PickListMoveAllToSourceEvent) {
    event.items.map(item => {
      this.paymentPageLinkData.paymentTypeIds.push(item.id);
    });
    this.dataChanged.emit();
  }

  /**
   * remove single payment method
   * @param event
   */
  removePaymentMethod(event: PickListMoveToTargetEvent) {
    event.items.map(item => {
      this.paymentPageLinkData.paymentTypeIds = this.paymentPageLinkData.paymentTypeIds.filter(id => id !== item.id);
    })
    this.dataChanged.emit();
  }

  /**
   * remove all selected payment-methods
   * @param event
   */
  removePaymentMethods(event: PickListMoveAllToTargetEvent) {
    event.items.map(item => {
      this.paymentPageLinkData.paymentTypeIds = this.paymentPageLinkData.paymentTypeIds.filter(id => id !== item.id);
    })
    this.dataChanged.emit();
  }

  /**
   * ann new amount to donation-amount list
   */
  addDonationAmount() {
    if (this.paymentPageLinkData.donationAmountList.find(item => item === (this.newDonationAmount * 100))) {
      this.messageService.add({
        life: 3500,
        severity: 'info',
        summary: this.i18n.i18nLng()['INFORMATION'],
        detail: this.i18n.i18nLng()['LINKNAMEEXISTS']
      });
    } else {
      this.paymentPageLinkData.donationAmountList.push(
        this.newDonationAmount * 100
      );
      this.newDonationAmount = null;
    }
    this.dataChanged.emit();
  }

  /**
   * remove amount from donation-amount list
   * @param amount
   */
  removeDonationAmount(amount: number) {
    this.paymentPageLinkData.donationAmountList = this.paymentPageLinkData.donationAmountList.filter(item => item !== amount);
    this.dataChanged.emit();
  }
}
